<template>
  <div>

    <table class="table">
      <thead>
      <tr>
        <th>Datum</th>
        <th>Period</th>
        <th>Betalningsdatum</th>
        <th>Summa</th>
        <th></th>
      </tr>
      </thead>

      <tbody>
        <tr v-for="invoice in invoices">
          <td class="align-middle">
            <small>
              {{ dayMonthYear(invoice.created_at) }}
            </small>
          </td>
          <td class="align-middle">
            <small>
              {{ dayMonth(invoice.from) }} - {{ dayMonth(invoice.to) }}
            </small>
          </td>
          <td class="align-middle">
            <small>
              {{ dayMonthYear(invoice.due_date) }}
            </small>
          </td>
          <td class="align-middle">
            <small>
              {{ invoice.total_sum_without_tax }} kr
              <small class="text-muted">
                (ex. moms)
              </small>
            </small>
          </td>
          <td class="align-middle">
            <router-link class="btn btn-outline-dark btn-sm" :to="{name: 'earnings.invoice', params: {uuid: invoice.uuid}}">
              <font-awesome-icon icon="file-alt" />
              Detaljer
            </router-link>
          </td>
        </tr>
      </tbody>
    </table>

  </div>
</template>

<script>

  import {mapState} from 'vuex'
  import DateMixin from "../../../../app/mixins/helpers/DateMixin"

  export default {
    name: "Invoices",
    mixins: [
      DateMixin
    ],
    computed: {
      ...mapState('earnings/invoices/collection', {
        invoices: state => state.collection,
        loaded: state => state.loaded,
      })
    },
    mounted(){
      return this.get()
    },
    destroyed(){
      this.$store.commit('earnings/invoices/collection/truncate')
    },
    methods: {
      get(page = 1){
        let input = {page, filter: {}}

        return this.$store.dispatch('earnings/invoices/collection/fetch', input)
      },
      next() {
        return this.get(this.pagination.current_page + 1)
      },
    },
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/Dashboard/Earnings/Partials/Invoices.vue